import { render, staticRenderFns } from "./widget-tab.vue?vue&type=template&id=93df7d84&scoped=true"
import script from "./widget-tab.vue?vue&type=script&lang=js"
export * from "./widget-tab.vue?vue&type=script&lang=js"
import style0 from "./widget-tab.vue?vue&type=style&index=0&id=93df7d84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93df7d84",
  null
  
)

export default component.exports